<script lang="ts">
	import type { FormConfig, SectionAll } from '$lib/config';
	import { page } from '$app/stores';
	import { onMount, SvelteComponent } from 'svelte';
	import { writable, type Writable } from 'svelte/store';
	//import { CenPOS } from '$lib/client/CenPOS';
	export let section: SectionAll;
	const formDef = $page.data as FormConfig;

	interface ComponentMap {
		[key: string]: typeof SvelteComponent;
	}
	const all_comp_imports = import.meta.glob('/src/lib/client/components/*.svelte', { eager: true });
	const componentsMap: { [key: string]: any } = {};
	Object.keys(all_comp_imports).forEach((path) => {
		const componentName = path.split('/').pop()?.replace('.svelte', '');
		if (componentName) {
			componentsMap[componentName] = all_comp_imports[path].default;
		}
	});
	const components: Writable<ComponentMap> = writable({});

	async function loadComponent(type: string) {
		if (!(type in $components)) {
			try {
				const component = componentsMap[type];
				components.update((current: { [x: string]: any }) => {
					current[type] = component;
					return current;
				});
			} catch (error) {
				console.error(`Error loading component ${type}:`, error);
			}
		}
	}

	// Load components based on the types present in the section data
	onMount(() => {
		section.Components.forEach((comp: any) => {
			loadComponent(comp.Type);
		});
	});
</script>

{#each section.Components as comp, i}
	{#if $components[comp.Type]}
		<svelte:component this={$components[comp.Type]} Config={comp} bind:this={comp.Comp} />
	{/if}
{/each}
